import { render, staticRenderFns } from "./Fitur.vue?vue&type=template&id=794a56b2&"
import script from "./Fitur.vue?vue&type=script&lang=js&"
export * from "./Fitur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports